import compressImage from "./reducirImagen";


export const fileUpload = async ( file ) => {

    if (!file) throw new Error ("No hay archivo a subir");
    // APLICA LA COMPRESIÓN AQUÍ
    let fileToUpload = file;

    try {
        // Intentamos comprimir la imagen al 25% de calidad.
        // Si falla la compresión, seguiremos subiendo el archivo original.

        fileToUpload = await compressImage(file, 0.24);

    } catch (error) {

        console.warn("Compression failed, uploading original file:", error);

    }

    // const cloudUrl = 'https://api.cloudinary.com/v1_1/dcl5ststo/upload'; Esta es la cuenta de Rony

    const cloudUrl = 'https://api.cloudinary.com/v1_1/dxfw3vkxp/upload'; // Esta es mi cuenta (ff_dassa)

    const formData = new FormData();
    formData.append("upload_preset", "globaclean");
    formData.append("file", fileToUpload)



    try {
        const resp = await fetch(cloudUrl, {
            method: 'POST',
            body: formData
        });

        if (!resp.ok) throw new Error("No se pudo subir imágen");
        const cloudResp = await resp.json();
        return cloudResp.secure_url;

    } catch (error) {

        console.log(error)

        throw new Error(error.message)

    }

}


// import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
// // Asegúrate de importar 'firebaseStorage' del archivo de configuración (ver paso 1)
// import { firebaseStorage } from './firebaseConfig'; // <-- Ajusta la ruta de importación

// // La función asume que el 'file' es un objeto File/Blob o ArrayBuffer
// export const fileUpload = async ( file ) => {

//     // 1. Verificación del Archivo
//     if ( !file ) {
//         // En este caso, el error se lanza inmediatamente, fuera del try/catch
//         throw new Error("No hay archivo a subir");
//     }

//     // 2. Crear una Referencia al Archivo
//     // Se crea un nombre único para el archivo para evitar colisiones
//     // y se define la ruta de subida (ej: 'files/imagen_unica_123.jpg')
//     const fileExtension = file.name.split('.').pop();
//     const fileName    = `${ new Date().getTime() }.${ fileExtension }`;
//     const storageRef  = ref( firebaseStorage, `files/${ fileName }` ); // 'files/' es la carpeta

//     try {
//         // 3. Subir el Archivo
//         // uploadBytes sube el archivo a la referencia creada
//         const snapshot = await uploadBytes( storageRef, file );
//         // snapshot contiene metadatos sobre la subida, como el nombre y la ruta

//         // 4. Obtener la URL Segura (Secure URL)
//         // getDownloadURL obtiene la URL de acceso público del archivo
//         const secureUrl = await getDownloadURL( snapshot.ref );

//         // 5. Devolver la URL
//         return secureUrl;

//     } catch ( error ) {
//         console.log(error);
//         // Puedes lanzar un error más específico si lo necesitas
//         throw new Error( "No se pudo subir la imagen a Firebase Storage" );
//     }

// }